// extracted by mini-css-extract-plugin
export default {"dropdown-wrap":"histogramDropdowns_dropdown-wrap__DuPf+","left":"histogramDropdowns_left__Wr40Z","right":"histogramDropdowns_right__kzIdc"};